import { z } from "zod";
import {
  ShiftSchema,
  invoiceContractorPaymentSchema,
} from "../createInvoice/createInvoice.schema";

/**
 * Request schema for GET /api/invoices/shifts
 * Response schema for GET /api/invoices/shifts
 */
export const getInvoiceLineItemsRequestSchema = z.object({
  customerAccountIDs: z.array(z.string()),
});

export type TGetInvoiceLineItemsRequest = z.infer<
  typeof getInvoiceLineItemsRequestSchema
>;

export const getInvoiceLineItemsResponseSchema = z.object({
  shifts: z.array(
    ShiftSchema.extend({
      workLocationName: z.string(),
    })
  ),
  contractor_payments: z.array(
    invoiceContractorPaymentSchema.extend({
      workLocationName: z.string(),
    })
  ),
});

export type TGetInvoiceLineItemsResponse = z.infer<
  typeof getInvoiceLineItemsResponseSchema
>;
